require( 'Modernizr' );

/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */

// Import custom modules
import JPList from 'jplist-es6/dist/1.2.0/jplist-es6.min.js';
import AOS from 'aos';
import MmenuLight from 'mmenu-light';
import fancybox from '@fancyapps/fancybox';
import simpleParallax from 'simple-parallax-js';
import Flickity from 'flickity';
import Typed from 'typed.js';

var supportsTouch = 'ontouchstart' in window;
var scrollPosition = window.scrollY;
var scrollTimeout = false;
var resizeTimeout;

var navBar = document.querySelector( '.navbar' );
var navBarHeight = navBar.clientHeight;
var navBarFill = document.querySelector( '.navbar-fill' );

var parallaxImages = document.querySelectorAll( '.parallax' );
var typedElement = document.getElementById( 'typed' );
var typedElements = document.querySelectorAll( '.typed' );
var cardsOverlay = document.querySelectorAll( '.cards-overlay' );
var accordions = document.querySelectorAll( '.accordions' );

var flickity = null;
var flickityCarousel = document.querySelector( '.carousel' );
let flickityIsPaused = false;
let flickityTickerSpeed = document.querySelector( '.employees-ticker-speed' );

const flickityWrapAround = () => {
  var flickityCells = flickityCarousel.querySelectorAll( '.carousel-cell' );
  var cellsTotalWidth = 0;

  if ( flickityCarousel && flickityCells ) {

    flickityCells.forEach( ( cell ) => {
      const style = window.getComputedStyle( cell );
      cellsTotalWidth += parseFloat( style.width ) + parseFloat( style.marginRight ) + parseFloat( style.marginLeft );
    });

    const carouselWidth = parseFloat( window.getComputedStyle( flickityCarousel ).width );

    return cellsTotalWidth >= carouselWidth;
  }

  return false;
};

const flickityTickerUpdate = () => {

  if ( flickityIsPaused ) {
    return;
  }

  if ( flickity.slides ) {
    flickity.x = ( flickity.x - flickityTickerSpeed ) % flickity.slideableWidth;
    flickity.selectedIndex = flickity.dragEndRestingSelect();
    flickity.updateSelectedSlide();
    flickity.settle( flickity.x );
  }

  window.requestAnimationFrame( flickityTickerUpdate );
};

const flickityTickerPause = () => {
  flickityIsPaused = true;
};

const flickityTickerPlay = () => {

  if ( flickityWrapAround() ) {

    if ( flickityIsPaused ) {
      flickityIsPaused = false;
      window.requestAnimationFrame( flickityTickerUpdate );
    }
  }
};

const nodeExists = ( node ) => {

  if ( typeof ( node ) != 'undefined' && node != null ) {
    return true;
  }

  return false;
};

window.addEventListener( 'scroll', () => {

  if ( ! scrollTimeout ) {

    scrollTimeout = setTimeout( () => {
      clearTimeout( scrollTimeout );
      scrollTimeout = false;
      scrollPosition = window.scrollY;

      if ( scrollPosition > 0 ) {
        navBar.classList.add( 'is-stuck' );
      } else {
        navBar.classList.remove( 'is-stuck' );
      }
    }, 100 );
  }
});

window.addEventListener( 'resize', () => {
  clearTimeout( resizeTimeout );

  resizeTimeout = setTimeout( () => {

    if ( nodeExists( navBarFill ) ) {
      document.querySelector( '.navbar-fill' ).style.height = navBar.clientHeight + 'px';
    }

    if ( nodeExists( cardsOverlay ) ) {
      setCardsOverlayHeight();
    }

    if ( nodeExists( flickity ) && 'reloadCells' in flickity ) {
      flickity.option({ wrapAround: flickityWrapAround() });
      flickity.reloadCells();

      if ( ! supportsTouch ) {

        if ( flickityWrapAround() ) {
          flickityTickerPlay();
        } else {
          flickityTickerPause();
        }
      }
    }
  }, 100 );
});

AOS.init({
  duration: 300,
  once: true
});

if ( nodeExists( navBarFill ) ) {
  document.querySelector( '.navbar-fill' ).style.height = navBarHeight + 'px';
}

if ( nodeExists( navBar ) && scrollPosition > 0 ) {
  navBar.classList.add( 'is-stuck' );
}

if ( nodeExists( typedElements ) ) {
  var i = 0;

  for ( i = 0; i < typedElements.length; i++ ) {
    var typedElement = typedElements[i];
    var blockElement = typedElement.parentElement.parentElement.parentElement.parentElement;
    var typedClassName = '.' + typedElement.className.replace( 'typed ', '' );
    var typedStringsClassName = '.' + typedElement.previousElementSibling.className.replace( 'typed-strings ', '' );
    var typingSpeed = typedElement.getAttribute('data-typing-speed');
    var backSpeed = typedElement.getAttribute('data-back-speed');

    if ( blockElement.classList.contains( 'first-block' ) ) {
      blockElement.style.height = 'calc(75vh - ' + navBarHeight + 'px)';
    }

    const typed = new Typed( typedClassName, {
      stringsElement: typedStringsClassName,
      typeSpeed: ( typingSpeed ) ? parseInt( typingSpeed ) : 50,
      startDelay: 300,
      backSpeed: ( backSpeed ) ? parseInt( backSpeed ) : 15,
      backDelay: 1000,
      smartBackspace: false,
      loop: true,
      cursorChar: '/'
    });
  }
}

if ( nodeExists( flickityCarousel ) ) {
  var flickityCells = flickityCarousel.querySelectorAll( '.carousel-cell' );

  if ( nodeExists( flickityTickerSpeed ) ) {
    flickityTickerSpeed = document.querySelector( '.employees-ticker-speed' ).textContent;
  }

  flickity = new Flickity( flickityCarousel, {
    wrapAround: flickityWrapAround(),
    freeScroll: true,
    initialIndex: Math.floor( flickityCells.length / 2 ),
    prevNextButtons: false,
    pageDots: false
  });

  if ( supportsTouch ) {
    // flickityCarousel.addEventListener( 'mouseenter', flickityTickerPause, false );
    flickityCarousel.addEventListener( 'focusin', flickityTickerPause, false );
  } else {
    flickityCarousel.addEventListener( 'mouseenter', flickityTickerPause, false );
    // flickityCarousel.addEventListener( 'focusin', flickityTickerPause, false );
    flickityCarousel.addEventListener( 'mouseleave', flickityTickerPlay, false );
    // flickityCarousel.addEventListener( 'focusout', flickityTickerPlay, false );
  }

  jQuery( '.flickity-slider' ).attr( 'data-jplist-group', 'employees' );

  if ( jplist ) {
    jplist.init();

    const element = document.querySelector( '[data-jplist-control]' );

    element.addEventListener( 'jplist.state', ( e ) => {
      flickityCarousel.classList.add( 'filtering' );

      if ( e.jplistState.filtered ) {
        flickity.option({ wrapAround: flickityWrapAround() });

        flickityCarousel.classList.remove( 'filtering' );

        if ( ! supportsTouch ) {

          if ( flickityWrapAround() ) {
            flickityTickerPlay();
          } else {
            flickityTickerPause();
          }

        }

        flickity.reloadCells();
        flickity.reposition();
        flickity.x = Math.floor( flickity.slideableWidth / -2 );
        flickity.selectedIndex = flickity.dragEndRestingSelect();
        flickity.updateSelectedSlide();
        flickity.settle( flickity.x );
        flickity.reloadCells();
      }
    }, false );
  }

  flickity.on( 'dragStart', () => {
    flickityIsPaused = true;
    flickityCarousel.classList.add( 'is-dragging' );
  });

  flickity.on( 'dragEnd', () => {
    flickityCarousel.classList.remove( 'is-dragging' );
  });

  if ( flickityWrapAround() ) {
    flickityTickerUpdate();
  }
}

if ( nodeExists( parallaxImages ) ) {

  new simpleParallax( parallaxImages, {
    scale: 1.2,
    delay: 0.3,
    'transition': 'ease',
    once: true
  });
}

if ( nodeExists( cardsOverlay ) ) {
  setCardsOverlayHeight();
}

if ( nodeExists( accordions ) ) {
  var i = 0;

  for ( i = 0; i < accordions.length; i++ ) {
    var j = 0;
    var accordionBar = accordions[i].getElementsByClassName( 'accordion-bar' );

    for ( j = 0; j < accordionBar.length; j++ ) {

      accordionBar[j].addEventListener( 'click', function() {
        var panel = this.nextElementSibling;
        this.parentElement.classList.toggle( 'active' );

        if ( panel ) {

          if ( panel.style.maxHeight ) {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }
        }
      });
    }
  }
}

if ( typeof fancybox !== 'undefined' ) {

  jQuery( '[data-fancybox]' ).fancybox({
    loop: true,
    arrows: false,
    animationDuration: 300,
    transitionEffect: 'slide',
    wheel: false
  });

  jQuery( '.employee-link' ).fancybox({
    btnTpl: {
      smallBtn: '<div data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">×</div>'
    },
    touch: false,
    beforeLoad: function( instance, current ) {
      jQuery( current.src ).removeClass( 'sr-only' );
    },
    afterShow: function() {
      flickityTickerPause();
    },
    beforeClose: function() {
      flickityTickerPlay();
    }
  });
}

if ( document.body.classList.contains( 'page-template-tpl-employees' ) ) {

  const togglePopover = ( $node ) => {
    $node.toggleClass( 'sr-only is-toggled' );
  };

  jQuery( '.employees-industry' ).on( 'click', ( e ) => {
    var $this = jQuery( e.currentTarget );
    var $popover = $this.next().next();

    if ( $popover.hasClass( 'is-toggled' ) ) {
      history.replaceState( null, null, './' );
      $popover.removeClass( 'sr-only is-toggled' );
    }
  });

  jQuery( '.btn-tooltip' ).on( 'click', ( e ) => {
    var $this = jQuery( e.currentTarget );
    var $next = $this.next();

    history.replaceState( null, null, './' );

    togglePopover( jQuery( '.popover.is-toggled' ).not( $next ) );

    if ( ! $next.hasClass( 'is-toggled' ) ) {
      history.pushState( null, null, $this.attr( 'href' ) );
    }

    togglePopover( $next );
    e.preventDefault();
  });

  jQuery( '.popover-btn' ).on( 'click', ( e ) => {
    history.replaceState( null, null, './' );
    togglePopover( jQuery( e.currentTarget ).parent() );
  });

  if ( window.location.hash ) {

    jQuery( '.btn-tooltip' ).each( ( i, e ) => {
      var $this = jQuery( e );

      if ( $this.attr( 'href' ) == window.location.hash ) {
        $this.prev().click();
        $this.click();
      }
    });

  }
}

document.addEventListener( 'DOMContentLoaded', () => {

  const menu = new MmenuLight(
    document.querySelector( '.site-nav' ),
    '(max-width: 1023px)'
  );

  const navigator = menu.navigation({
    theme: '',
    title: ''
  });

  const drawer = menu.offcanvas({
    position: 'right'
  });

  document.querySelector( 'a[href="#site-nav"]' ).addEventListener( 'click', ( evnt ) => {
    evnt.preventDefault();

    if ( document.body.classList.contains( 'mm-ocd-opened' ) ) {
      drawer.close();
    } else {
      drawer.open();
    }

  });
});

function setCardsOverlayHeight() {
  var i = 0;

  for ( i = 0; i < cardsOverlay.length; i++ ) {
    var j = 0;
    var cardOverlay = cardsOverlay[i].getElementsByClassName( 'card-overlay-title' );
    var cardHeight = 0;

    for ( j = 0; j < cardOverlay.length; j++ ) {
      cardOverlay[j].style.height = '';
      cardHeight = Math.max(cardHeight, cardOverlay[j].clientHeight)
    }

    for ( j = 0; j < cardOverlay.length; j++ ) {
      cardOverlay[j].style.height = cardHeight + 'px';
    }
  }
}
